export interface IConditionlDelayBlockModel {
    interval: number;
    unit: string;
    type: string;
    col_name: string;
    event_method: string | 'pass on before' | 'pass on after';
    fieldLabel: string;
}
export class ConditionlDelayBlockModel implements IConditionlDelayBlockModel {
    col_name: string = '';
    event_method: string = 'pass on before';
    fieldLabel: string = '';
    interval: number = 0;
    type: string = 'conditional';
    unit: string = 'Hours';
    constructor(data: object = undefined) {
        if(data) {
            for( const key in data ) {
                if(this.hasOwnProperty(key)) {
                    this[key] = data[key];
                }
            }
        }
    }

}
